import { Component } from 'react';

class ExtraButtons extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <>
                <div className="table-header-subtitle mb-15">
                    Optimize keywords ranking position 6 - 20 to maximize traffic. We have selected
                    top 100 most impacted keywords over the past 90 days.
                </div>
            </>
        );
    }
}

export default ExtraButtons;
